module.exports = __webpack_public_path__ + "img/グループ 573.510392bc.png";